import { Render, Data } from '@measured/puck';

import { createConfig } from '../config/puck.config';
import { LandingPageMetadata } from '../types';

type IPuckRenderProps = {
  readonly reportDefinition: Data;
  readonly metadata: LandingPageMetadata;
};

function PuckRender({ metadata, reportDefinition }: IPuckRenderProps) {
  const config = createConfig({ metadata });
  return <Render config={config} data={reportDefinition} metadata={metadata} />;
}

export { type IPuckRenderProps, PuckRender as Render };
